import { render, staticRenderFns } from "./cdn-image.vue?vue&type=template&id=9a8931fc&scoped=true&"
import script from "./cdn-image.vue?vue&type=script&lang=js&"
export * from "./cdn-image.vue?vue&type=script&lang=js&"
import style0 from "./cdn-image.vue?vue&type=style&index=0&id=9a8931fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8931fc",
  null
  
)

export default component.exports